import api from "..";

export const fetchBusinessAndEnterpriseDashboardStats = (params = {}, callBack) => {
    api.get(`/dashboard/stats/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};
export const getTheStorage = (params = {}, callBack) => {
    api.get(`/storage-usage/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

